import { render } from "./ads.Tataonline.vue?vue&type=template&id=6fcd6a86"
import script from "./ads.Tataonline.vue?vue&type=script&lang=js"
export * from "./ads.Tataonline.vue?vue&type=script&lang=js"

import "./ads.Tataonline.vue?vue&type=style&index=0&id=6fcd6a86&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__